module.exports = __webpack_public_path__ + "img/u_folder.3ae76020.svg";